<template>
  <div class="side-frame-success d-flex align-items-center">
    <div>
      <span style="font-size: 14px; color: #606266">{{
        $l('group_title_merchandiser') || '业务跟单'
      }}</span>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-radio-group
      v-model="form.inputType"
      fill="#317CF6"
      size="small"
      @change="query"
    >
      <el-radio-button label="A">在手单</el-radio-button>
      <el-radio-button label="B">新订单</el-radio-button>
    </el-radio-group>
    <div class="ml-2" style="width:300px;">
      <b-input-group size="sm">
        <b-form-input
          @keyup.enter="query"
          type="search"
          v-model.trim="form.keyword"
          :placeholder="$l('tips_input_search') || '输入跟单人员...'"
        />
        <b-input-group-append>
          <b-button-group>
            <b-button-group slot="reference">
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-button-group>
          </b-button-group>
        </b-input-group-append>
      </b-input-group>
    </div>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  inputType: 'A'
}
export default {
  props: {},
  data() {
    return {
      form: { ...initForm }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 重置查询条件
    reset() {
      this.form = { ...initForm }
    },
    query() {
      this.$emit('query', this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
